export default "/images/buy-home-icon.svg?5ad9ac791ac26056ff0947e13c01c84a";